import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Sparkles } from "lucide-react";
import { NAV } from "./content";

const Logo = ({ light = false }) => (
  <a href="#top" data-testid="nav-logo" className="flex items-center select-none">
    <img
      src="/img/logo-doremigos.png"
      alt="DóRéMigos"
      className={`h-16 w-auto transition-all duration-300 ${light ? "brightness-0 invert" : ""}`}
    />
  </a>
);

export const Nav = ({ onContact }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
      className="fixed inset-x-0 top-0 z-50"
    >
      <div
        className={`mx-auto flex max-w-[1400px] items-center justify-between px-5 transition-all duration-500 md:px-8 ${
          scrolled ? "my-3" : "my-5"
        }`}
      >
        <div
          className={`flex w-full items-center justify-between rounded-full border px-5 py-3 transition-all duration-500 ${
            scrolled
              ? "border-black/5 bg-dm-cream/80 shadow-[0_10px_30px_rgba(0,0,0,0.06)] backdrop-blur-xl"
              : "border-transparent bg-transparent"
          }`}
        >
          <Logo />

          <nav className="hidden items-center gap-8 lg:flex">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                data-testid={`nav-link-${item.label.toLowerCase()}`}
                className="group relative text-sm font-semibold text-dm-ink/80 transition-colors hover:text-dm-ink"
              >
                {item.label}
                <span className="absolute -bottom-1 left-0 h-[2px] w-0 rounded-full bg-dm-guita transition-all duration-300 group-hover:w-full" />
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              onClick={onContact}
              data-testid="nav-cta-license"
              className="group hidden items-center gap-2 rounded-full bg-dm-ink px-5 py-2.5 text-sm font-semibold text-dm-cream transition-transform duration-300 hover:scale-105 sm:flex"
            >
              <Sparkles className="h-4 w-4 text-dm-keys transition-transform duration-500 group-hover:rotate-90" />
              Quero licenciar
            </button>
            <button
              data-testid="nav-menu-toggle"
              onClick={() => setOpen((v) => !v)}
              className="grid h-10 w-10 place-items-center rounded-full bg-dm-ink text-dm-cream lg:hidden"
              aria-label="Menu"
            >
              {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </button>
          </div>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="mx-5 rounded-3xl border border-black/5 bg-dm-cream/95 p-6 shadow-xl backdrop-blur-xl lg:hidden"
          >
            <div className="flex flex-col gap-4">
              {NAV.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setOpen(false)}
                  data-testid={`nav-mobile-${item.label.toLowerCase()}`}
                  className="font-display text-2xl font-bold text-dm-ink"
                >
                  {item.label}
                </a>
              ))}
              <button
                onClick={() => { setOpen(false); onContact(); }}
                className="mt-2 rounded-full bg-dm-ink px-5 py-3 text-center font-semibold text-dm-cream"
              >
                Quero licenciar
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};

export { Logo };
